// extracted by mini-css-extract-plugin
export default {"mailLoginPageContainer":"MailLoginPage_mailLoginPageContainer__xY7qF"};